import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/inspektionen',
      name: 'inspektionen',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Inspektionen.vue')
    },
    {
      path: '/inspektionanlage',
      name: 'inspektionanlage',
      component: () => import('./views/InspektionAnlage.vue')
    },
    {
      path: '/inspektion_mauer',
      name: 'inspektion_mauer',
      beforeEnter: (to, from, next) => {
        if (from.name === 'inspektionen') {
          window.scroll(0, 0)
        }

        next()
      },
      component: () => import('./views/Inspektion_Mauer.vue')
    },
    {
      path: '/massnahme_mauer/:id',
      name: 'massnahme_mauer',
      component: () => import('./views/Massnahme_Mauer.vue')
    },
    {
      path: '/inspektion_durchlass',
      name: 'inspektion_durchlass',
      beforeEnter: (to, from, next) => {
        if (from.name === 'inspektionen') {
          window.scroll(0, 0)
        }

        next()
      },
      component: () => import('./views/Inspektion_Durchlass.vue')
    },
    {
      path: '/massnahme_durchlass/:id',
      name: 'massnahme_durchlass',
      component: () => import('./views/Massnahme_Durchlass.vue')
    },
    {
      path: '/status',
      name: 'status',
      component: () => import('./views/Status.vue')
    }
  ]
})
